import { render, staticRenderFns } from "./MainKOF.vue?vue&type=template&id=2a4ad39e&"
import script from "./MainKOF.vue?vue&type=script&lang=js&"
export * from "./MainKOF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports